enum StorageKey {

    APMTransRefNum = "__aspmtrn",
    PreviousQueryString = "__pqs",
    BackToPlatformButton = "__btpbtn",
    PackageId = "__pkgid",
}

export {
    StorageKey
}
